var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        transition: "scroll-x-transition",
        "overlay-color": "grey darken-2",
        "content-class": "ec-confirmation-dialog overflowY-auto",
        width: "600",
        persistent: "",
      },
      model: {
        value: _vm.dialogModel,
        callback: function ($$v) {
          _vm.dialogModel = $$v
        },
        expression: "dialogModel",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { color: "accent", width: "600" } },
        [
          _c(
            "v-card-title",
            {
              staticStyle: { "background-color": "#47bd96", color: "white" },
              attrs: { dark: "" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.quoteConnectionType.text) +
                  " connection properties: "
              ),
            ]
          ),
          _c(
            "v-card-text",
            { staticClass: "pb-0 pt-5 text-center" },
            [
              _c(
                "v-form",
                {
                  ref: "quoteConnectionform",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-row",
                    _vm._l(_vm.connectionFields, function (field) {
                      return _c(
                        "v-col",
                        {
                          key: field.text,
                          staticClass: "pb-0 pt-1",
                          attrs: { cols: "12", sm: "6" },
                        },
                        [
                          field.name === "EncryptMethod"
                            ? _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "menu-props": {
                                    offsetY: true,
                                    maxHeight: "250",
                                  },
                                  label: "Encryption method",
                                  items: _vm.currentEncryptionMethods,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prepend-item",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-list-item",
                                            {
                                              staticClass: "px-2",
                                              staticStyle: {
                                                "max-height": "40px",
                                                "border-bottom":
                                                  "1px solid #7f7f7f",
                                              },
                                              attrs: { ripple: "" },
                                            },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticStyle: {
                                                        "font-size":
                                                          "14px !important",
                                                        "font-weight": "400",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "mx-1 mt-1 mb-0",
                                                          staticStyle: {
                                                            "border-top":
                                                              "none !important",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "mt-2 px-2",
                                                              attrs: {
                                                                text: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.addNewEncryptMethod,
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-plus-circle mr-1",
                                                                staticStyle: {
                                                                  color:
                                                                    "#47bd96",
                                                                },
                                                              }),
                                                              _vm._v(
                                                                " New method "
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mini-text-field ml-3",
                                                            staticStyle: {
                                                              width:
                                                                "84px !important",
                                                              "margin-top":
                                                                "8px",
                                                            },
                                                            attrs: {
                                                              outlined: "",
                                                              dense: "",
                                                              placeholder:
                                                                "...",
                                                              "hide-details":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.newEncryptionMethod,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.newEncryptionMethod =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "newEncryptionMethod",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              })
                            : field.type === "boolean"
                            ? _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "menu-props": { offsetY: true },
                                  "item-text": "text",
                                  label: field.text,
                                  items: [
                                    { value: true, text: "Yes" },
                                    { value: false, text: "No" },
                                  ],
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item",
                                      fn: function ({ item }) {
                                        return [
                                          _c("p", { staticClass: "mb-0" }, [
                                            _vm._v(_vm._s(item.text)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              })
                            : field.type === "number"
                            ? _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  label: field.text,
                                  type: "number",
                                  rules: [
                                    field.required ? _vm.rules.required : true,
                                  ],
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", _vm._n($$v))
                                  },
                                  expression: "field.value",
                                },
                              })
                            : _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  outlined: "",
                                  label: field.text,
                                  rules: [
                                    field.required ? _vm.rules.required : true,
                                  ],
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "pt-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: { click: _vm.cancelQuoteConnectionDialog },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", type: "submit" },
                  on: {
                    click: function ($event) {
                      return _vm.saveQuoteConnectionProperties()
                    },
                  },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }